module.exports = __webpack_public_path__ + "img/kg4002_center_002.f95b28e7.png";